import React, { useState } from 'react';
import { v4 } from 'uuid';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useRootStore } from 'app/contexts/RootStoreContext';
import NewCustomDashboardPanelModal from 'shared/components/NewCustomDashboardPanelModal';
import * as custDabrdHelpers from 'usage/containers/CostAndUsageExplorer/helpers/customDashboardHelperMethods';
import { palette } from 'shared/constants/colorsConstants';
import ButtonDropdown from 'shared/components/andtComponents/ButtonDropdown';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { useRecommendationsNewContext } from '../../../contexts/recommendationsNewContext';
import { useHeatMapContext } from '../contexts/heatMapContext';
import { CategoryAction, HierarchicalEntityCategory } from '@anodot-cost/rbac-client';
import ReadOnlyDisplayWrapper from 'shared/components/ReadOnlyDisplayWrapper';
import { WASTE_TAB_KEYS } from 'recommendationsNew/consts.js';
import classes from './heatMapActions.module.scss';

const dashboardIcon = () => <GenerateIcon iconName={ICONS.dashboard.name} />;
const SaveAsDashboardPanel = () => {
  const [dashboardModalIsOpen, setDashboardModalIsOpen] = useState(false);
  const { usageStore, usersStore } = useRootStore();
  const cloudType = usersStore?.currDispUserCloudAccountType;
  const { existingDashboardsNamesAndIds } = usageStore.customDbSubStore.customDashboardModel;
  const [customPanelType, setCustomPanelType] = useState('heat-map');
  const { recommendationFilters: filtersContext } = useRecommendationsNewContext();
  const {
    heatMapSortByOption: sortByContext,
    heatMapGroupByOptions,
    dateGranularity,
    wasteTabSelected,
  } = useHeatMapContext();
  const getParamsForCustomDashboard = () => ({ id: v4().substring(0, 6).toLowerCase() });
  const savePanel = (panelType) => {
    setDashboardModalIsOpen(true);
    setCustomPanelType(panelType);
  };

  const renderDashboardType = () => {
    if (wasteTabSelected === WASTE_TAB_KEYS.wasteMap) {
      return (
        <div
          className={classes.actionsPanelButton}
          onClick={() => {
            savePanel('heat-map');
          }}
        >
          <Tooltip title="Save as Dashboard Panel" classes={{ tooltip: classes.customTooltip }}>
            <div className={classes.actionsPanelButton} automation-id="heatmap-create-dashboard">
              <GenerateIcon iconName={ICONS.dashboard.name} />
            </div>
          </Tooltip>
        </div>
      );
    }
    const tablePanel = wasteTabSelected === WASTE_TAB_KEYS.wasteChart ? 'saving-opportunities' : 'saving-tracker';
    const chartPanel = wasteTabSelected === WASTE_TAB_KEYS.wasteChart ? 'cloud-waste' : 'accumulated-savings';
    return (
      <ButtonDropdown
        text=""
        isTextButton
        overrideButtonStyles={{ background: palette.blue[500], color: '#ffffff', width: '36px', fontSize: '16px' }}
        className={classes.actionsPanelButton}
        overrideMenuStyles={{ display: 'flex', flexDirection: 'column' }}
        icon={dashboardIcon}
        automationid="saveDasboard"
      >
        <button onClick={() => savePanel(tablePanel)} id={tablePanel} className={classes.menuItem}>
          <span>{tablePanel.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</span>
        </button>
        <button onClick={() => savePanel(chartPanel)} id={chartPanel} className={classes.menuItem}>
          <span>{chartPanel.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</span>
        </button>
      </ButtonDropdown>
    );
  };
  return (
    <>
      <ReadOnlyDisplayWrapper
        isHide={false}
        category={HierarchicalEntityCategory.Dashboards}
        action={CategoryAction.Create}
      >
        {renderDashboardType()}
      </ReadOnlyDisplayWrapper>

      <NewCustomDashboardPanelModal
        modalIsOpen={dashboardModalIsOpen}
        getCurrentCauParams={getParamsForCustomDashboard}
        onClose={() => {
          setDashboardModalIsOpen(false);
          setCustomPanelType(null);
        }}
        customDashboardStore={usageStore.customDbSubStore}
        existingDashboardsNamesAndIds={existingDashboardsNamesAndIds}
        helpers={custDabrdHelpers}
        type={customPanelType}
        state={{
          filterContext: filtersContext,
          groupBy: heatMapGroupByOptions,
          sortBy: sortByContext,
          dateGranularity: dateGranularity,
          wasteTabSelected,
        }}
        isSelectTimePeriodEnabled={false}
        usageStore={usageStore}
        cloudType={cloudType}
      />
    </>
  );
};

export default SaveAsDashboardPanel;
